import React from 'react';

import BarRatingItem from './bar-rating-item/bar-rating-item';

import './bar-rating.scss';

export interface AverageRating {
  label: string;
  value: number;
}

interface BarRatingProps {
  averageRatings: AverageRating[];
  className?: string;
  heading?: string;
}

function BarRating(props: BarRatingProps) {
  const { averageRatings, className, heading = '' } = props;

  return (
    <div className={`${className || ''} bar-rating`} styleName="container">
      {heading && <h5 styleName="section-heading">{heading}</h5>}
      <div className="bar-rating__ratings" styleName="average-ratings">
        <div
          className="bar-rating__ratings-section"
          styleName="average-ratings-section"
        >
          {averageRatings.map(averageRating => (
            <BarRatingItem
              averageRating={averageRating}
              key={averageRating.label}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export { BarRatingItem };
export default BarRating;
